import VendorAnalyse from "lottie/VendorAnalyse.json";
import Lottie from "lottie-react";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { Button } from "./DesignSystem/Button/Button";
import { SmallArrowUpRight } from "./icons/SmallArrowUpRight";

export const AnalyseBankStatement = ({
  season,
  redirectToVendor,
}: {
  season: string;
  redirectToVendor?: () => void;
}) => {
  const { isAdmin } = useRoleBasedView();

  return (
    <div className="t-w-full t-h-full t-flex t-justify-center t-items-center">
      <div className="t-w-1/2 t-text-center">
        <Lottie className="t-h-32" animationData={VendorAnalyse} />
        <div className="t-text-subtitle-lg t-text-text-100 t-mt-3">
          We’re analysing your bank transactions
        </div>
        <div className="t-text-subtext t-text-text-30 t-mt-0.5">
          Please wait while we identify all your eligible vendors for the year{" "}
          {season}. <br />
          This may take up to 24 hours. We’ll notify you once it’s ready.
        </div>
        {isAdmin && redirectToVendor && (
          <div className="t-mt-6">
            <Button
              size="small"
              rightIcon={<SmallArrowUpRight className="t-size-2" />}
              onClick={redirectToVendor}
            >
              View all vendors
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
